import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import '../../css/TagSelector.css';

const TagSelector = ({ selectedTags, setSelectedTags, options = [], placeholder, handleTagChange }) => {
    const { t } = useTranslation();
    const resolvedPlaceholder = placeholder ?? t('media.media_select_tags');
    // const [selectedTags, setSelectedTags] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);

    const toggleDropdown = () => setIsOpen(prev => !prev);

    const handleSelect = (tag) => {
        if (!selectedTags.find(t => t.id === tag.id)) {
            const updated = [...selectedTags, tag];
            setSelectedTags(updated);
            handleTagChange(updated.map(t => t.id)); // ✅ send IDs to parent
        }
    };

    const handleRemove = (tag) => {
        const updated = selectedTags.filter(t => t.id !== tag.id);
        setSelectedTags(updated);
        handleTagChange(updated.map(t => t.id)); // ✅ send IDs to parent
    };

    const filteredOptions = options.filter(tag => !selectedTags.find(t => t.id === tag.id));

    // close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className="tag-selector" ref={containerRef}>
            <div className="tag-selector-input" onClick={toggleDropdown}>
                <span className="tag-placeholder">{resolvedPlaceholder}</span>

            </div>

            {isOpen && (
                <div className="tag-dropdown">
                    {selectedTags.length > 0 &&
                        <div className="py-2">
                            {selectedTags.map(tag => (
                                <div className='flex justify-between items-center px-2'>
                                    <span key={tag.id} className="tag-chip">
                                        {tag.name.length > 15 ? tag.name.slice(0, 14) + "..." : tag.name}
                                    </span>
                                    <span
                                        className="remove-tag"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleRemove(tag);
                                        }}
                                    >
                                        ×
                                    </span>
                                </div>
                            ))}
                        </div>}
                    <hr className='mb-1 mt-0' />
                    {filteredOptions.length > 0 ?
                        filteredOptions.map(tag => (
                            <div
                                key={tag.id}
                                className="tag-option"
                                onClick={() => handleSelect(tag)}
                            >
                                {tag.name.length > 15 ? tag.name.slice(0, 14) + "..." : tag.name}
                            </div>
                        ))
                        :
                        <small className="h-10 flex justify-center items-center w-100">{t('media.media_no_tags_found')}</small>
                    }

                </div>
            )}
        </div>
    );
};

export default TagSelector;
